import * as React from "react";

export const useUpdatePositionOnScroll = (isOpened: React.MutableRefObject<boolean>) => {
    const [, updateDummy] = React.useState(1);

    React.useEffect(() => {
        const onScroll = () => {
            if (isOpened.current) {
                updateDummy(v => ++v);
            }
        };
        window.addEventListener("scroll", onScroll, true);
        return () => {
            return window.removeEventListener("scroll", onScroll, true);
        };
    }, []);
};
